// Full project data - LATEST VERSION ONLY
// This file contains complete project information and is only included in latest builds

import { projectSummaries } from './projects.js';

// Full projects data with additional fields for latest version
export const projects = {
    'remote-agent': {
        ...projectSummaries['remote-agent'],
        contentAvailable: true,
    },
    'automations': {
        ...projectSummaries['automations'],
        contentAvailable: true,
    },
    'meds': {
        ...projectSummaries['meds'],
        contentAvailable: true,
    },
    // 'b2b-engagement': {
    //     ...projectSummaries['b2b-engagement'],
    //     contentAvailable: true,
    // },
    'globezones': {
        ...projectSummaries['globezones'],
        contentAvailable: true,
    },
    'icantcope': {
        ...projectSummaries['icantcope'],
        contentAvailable: true,
    },
    'observe': {
        ...projectSummaries['observe'],
        contentAvailable: true,
    },
    'cmdgit': {
        ...projectSummaries['cmdgit'],
        contentAvailable: true,
    }
};

// Helper function to get project by slug (uses slug property as source of truth)
export const getProjectBySlug = (slug) => {
    const project = Object.values(projects).find(project => project.slug === slug);
    return project || { 
        title: 'Project Not Found', 
        description: 'This project doesn\'t exist.',
        company: 'other',
        period: 'Unknown'
    };
};

// Helper function to get projects by company
export const getProjectsByCompany = (companyKey) => {
    return Object.values(projects).filter(project => project.company === companyKey);
};

const isInternalCaseStudy = (project) => Boolean(project?.slug) && !project.externalLink;

// Helper function to get project order (internal case studies only)
export const getProjectOrder = () => {
    return Object.values(projects)
        .filter(isInternalCaseStudy)
        .map(project => project.slug);
};

// Helper function to get next project slug
export const getNextProjectSlug = (currentSlug) => {
    const projectOrder = getProjectOrder();
    const currentIndex = projectOrder.indexOf(currentSlug);
    if (currentIndex >= 0 && currentIndex < projectOrder.length - 1) {
        return projectOrder[currentIndex + 1];
    }
    return projectOrder[0]; // Loop back to first project
};
